import React, {Component} from 'react';
import {w3cwebsocket as W3CWebSocket} from "websocket";
import Header from "./Header";
import OccupancyChart from "./OccupancyChart";
import ForceOccupancyForm from "./ForceOccupancyForm";
import DebugLog from "./DebugLog";
import {Link} from "react-router-dom";

const translate = require('../../translate');

class Operation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            operationId: props.match.params.operationId,
            connectionStatus: 'Unknown',
            err: null,
            metadata: {}
        };

        this.connectWS = this.connectWS.bind(this);
        this.startWS = this.startWS.bind(this);
    }

    componentDidMount() {
        if (this.state.operationId.startsWith("demo")) {
            fetch('/' + this.state.operationId + '/operationMeta.json')
                .then(response => response.json())
                .then(metadata => this.setState({metadata}));
            fetch('/' + this.state.operationId + '/occupancy.json')
                .then(response => response.json())
                .then(data => this.setState({data: data, connectionStatus: "OK"}));
        } else {
            fetch('/operationMeta?id=' + this.state.operationId, {
                headers: { 'Authorization': this.props.token }
            })
                .then(response => response.json())
                .then(metadata => {
                    this.setState({err: metadata.err});
                    if (!metadata.err) {
                        this.startWS(metadata.streamingApi, metadata.id);

                        let language = this.props.language || metadata.country;

                        this.setState({metadata, language});
                    }
                });
        }
    }

    startWS(url, id) {
        this.connectWS(url, id);

        let timer = setInterval(() => {
            this.checkWS(url, id);
        }, 10 * 1000);

        this.setState({timer});
    }

    checkWS(url, id) {
        if (!this.state.client && this.state.metadata.streamingApi) {
            this.connectWS(url, id);
        }
    }

    connectWS(url, id) {
        let client = new W3CWebSocket(`wss://${url}/occupancy`);
        this.setState({client});

        let { token } = this.props;

        setTimeout(() => {
            if(this.state.client && this.state.client.readyState !== 1) {
                this.state.client.close();
                this.setState({client: null});
            }
        }, 5*1000);

        client.onopen = () => {
            console.log('WebSocket Client Connected');
            client.send(JSON.stringify({ token, operation_id: id }));
            this.setState({connectionStatus: 'OK'});
        };
        client.onmessage = (message) => {
            this.setState({data: JSON.parse(message.data)})
        };
        client.onclose = () => {
            console.log("WebSocket Client Closed");
            this.setState({client: null});
        };
        client.onerror = () => {
            console.log("WebSocket Client Error");
            this.setState({connectionStatus: 'Error'});
        }
    }

    componentWillUnmount () {
        clearTimeout(this.state.timer);
        if(this.state.client) this.state.client.close();
    }

    render() {

        let meta = this.state.metadata;
        let data = this.state.data;
        let currentOccupancy = data ? data.currentOccupancy : undefined
        let language = this.state.language;
        let videoUrl = (language === 'sk' || language === 'cz') ? 'https://www.youtube.com/embed/B4kfyKYCW6o' : 'https://www.youtube.com/embed/oaVK2oUxHMI'

        if(this.state.err){
            return <h1>{this.state.err}</h1>;
        } else if(this.props.token === "" && !this.state.operationId.startsWith("demo")) {
            return <p>Missing token</p>;
        } else if (meta) {
            return (
                <div id="app-container">
                    <div className="container grid-sm">
                        <div className="columns mt-2">
                            <div className="column col-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={'/organization/' + meta.organizationId}>{meta.organizationName}</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href={'#'}>{meta.name}</a>
                                    </li>
                                </ul>

                                {data &&
                                <Header connectionStatus={this.state.connectionStatus}
                                        occupancy={currentOccupancy}
                                        max_occupancy={data.maxOccupancy}
                                        critical_occupancy={data.criticalOccupancy}
                                        language={language}
                                        isOpen={data ? data.isOpen : true}/>
                                }

                                {data && data.data &&
                                <div className="card-body text-center mt-2">
                                    <div className="text-left pt-2">
                                        {translate(language, 'Daily trend:')}
                                    </div>

                                    <OccupancyChart data={data}/>
                                </div>
                                }

                                <div className="card-body text-center mt-2">
                                    <Link className='btn btn-sm btn-link' to={'/semaphore/' + meta.id}>
                                        {translate(language, 'Show traffic lights')}
                                    </Link>
                                    <ForceOccupancyForm
                                        language={language}
                                        operationId={meta.id}
                                        streamingApi={meta.streamingApi}
                                        token={this.props.token}/>
                                    <DebugLog
                                        language={language}
                                        streamingApi={meta.streamingApi}
                                        token={this.props.token}
                                        operationId={meta.id}
                                    />
                                </div>
                            </div>

                            <React.Fragment>
                                <div className="column col-12" style={{padding: 20}}>&nbsp;</div>
                                <div className="column col-3">&nbsp;</div>
                                <div className="column col-6 col-sm-12">
                                    <div className="video-responsive video-responsive-4-3">
                                        <iframe width="560" height="315" src={videoUrl}
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen/>
                                    </div>
                                </div>
                            </React.Fragment>
                        </div>
                    </div>
                </div>
            );
        } else return <div></div>;
    }
}

export default Operation;